import "../../styles/SectionPartyEvent.css"
import {getIcon} from "../../utils/helper";
import {useState} from "react";
import ModalContact from "./includes/ModalContact";

const SectionPartyEvent = () => {
    const [openModal, setOpenModal] = useState(false)
    return (
        <section className="section about text-center" id={"party-event"} aria-labelledby="about-label">
            <div className="container">

                <div className="party-content">
                    <div className="wrap-title">
                        <div className="icon-title">
                            <img src="/assets/images/badge-1.png" width="28" height="41" loading="lazy" alt="badge"
                                 className=" "/>
                        </div>
                        <div className="title">
                            <p className="label-2 section-subtitle slider-reveal">Party Catering & Events</p>
                            <div className="icon-separator">
                                {getIcon("separator")}
                            </div>
                        </div>
                    </div>
                    <h2 className="headline-1 section-party-title section-title">
                        Party Catering & Events bei Ha Mi – Kulinarisch genießen in Freiberg
                    </h2>
                    <div className="section-party-text">
                        <p>
                            Ob bei Ihnen zu Hause oder direkt in unserem Restaurant – <strong>Ha Mi</strong> bietet das
                            perfekte Catering für jede Feier.
                            Von <strong>vietnamesischen Spezialitäten</strong> über <strong>frisches Sushi</strong> bis
                            hin zu <strong>traditioneller deutscher Küche</strong> –
                            wir verbinden internationale Aromen mit beliebten Klassikern.
                        </p>
                        <p>
                            Unser modernes Restaurant bietet Platz für <strong>bis zu 100 Gäste</strong> – und bei
                            schönem Wetter erweitern wir die Kapazität auf <br/>
                            <strong>bis zu 200 Personen</strong> in unserem <strong>großzügigen Biergarten</strong>.
                            Perfekt für Hochzeiten, Firmenfeiern, Geburtstage oder Sommerfeste.
                        </p>

                        <h3>Unsere kulinarischen Highlights:</h3>
                        <ul>
                            <li><strong>Sushi & asiatische Küche</strong> – frisch, leicht & raffiniert</li>
                            <li><strong>Deutsche & europäische Klassiker</strong> – herzhaft bis fein</li>
                            <li><strong>BBQ-Buffets & Live-Cooking</strong> – auf Wunsch direkt vor Ort</li>
                            <li><strong>Individuelle Menügestaltung</strong> – auch vegetarisch, vegan &
                                allergikerfreundlich
                            </li>
                        </ul>

                        <h3>Unser Rundum-Service:</h3>
                        <ul>
                            <li>Catering bei Ihnen vor Ort oder direkt bei Ha Mi</li>
                            <li>Komplettpakete inklusive Dekoration, Personal, Technik & Musik</li>
                            <li>Planung und Betreuung Ihrer Veranstaltung von A bis Z</li>
                            <li>Lieferung in Freiberg und Umgebung</li>
                        </ul>

                        <p><strong>Kontaktieren Sie uns jetzt für eine unverbindliche Beratung – wir freuen uns darauf,
                            Ihre Feier unvergesslich zu machen!</strong></p>
                    </div>



                    <div className="wrapBtn" onClick={()=>{
                        setOpenModal(true)
                    }}>
                        {/*<div className="contact-label">Ansprechpartner: Ronny Löser </div>*/}
                        <button type="button" className={`btnSecondary btn`}>
                            <span className={`text text1`}>Anfrage</span>
                            <span className={`text text2`} aria-hidden="true">Anfrage</span>
                        </button>
                    </div>

                </div>
                <div className="party-images">
                    <img src="/assets/images/sel.jpeg" loading="lazy"
                         alt="about banner" className="w-100" data-parallax-item="" data-parallax-speed="1"/>
                </div>

            </div>
            <ModalContact openModal={openModal} setOpenModal={setOpenModal}/>
        </section>
    )
}
export default SectionPartyEvent